export default abstract class PageModel {
    static moduleName = '';
    static moduleEntityName? = '';
    static listTitle = '';
    static createTitle? = '';
    static apiPrefix = '';
}